export default {
  'menu.workbench': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.template': '模板示例',
  'menu.login': '登錄',
  'menu.settings': '設定',
  'menu.settings.reimbursement': '報銷設定',
  'menu.settings.anomalyRules': '異常規則',
  'menu.settings.buyers': '購買方設定',
  'menu.settings.expenseCategories': '費用類型',
  'menu.settings.sceneTemplates': '場景模板',
  'menu.settings.personalQuotaConfigs': '個人額度',
  'menu.settings.expenseStandardPolicies': '費用標準',
  'menu.settings.permissions': '權限管理',
  'menu.reimbursements': '報銷管理',
  'menu.reimbursements.dashboard': '報銷工作台',
  'menu.reimbursements.invoices': '發票採集',
  'menu.reimbursements.invoices.my': '我的發票',
  'menu.reimbursements.invoices.all': '全部發票',
  'menu.reimbursements.claims': '報銷單',
  'menu.reimbursements.claims.my': '我的報銷單',
  'menu.reimbursements.claims.all': '全部報銷單',
  'menu.reimbursements.approval': '審批中心',
  'menu.reimbursements.claimEdit': '填寫報銷單',
  'menu.reimbursements.analytics': '數據統計分析',
  'menu.reimbursements.myAnalytics': '我的統計',
  'menu.reimbursements.managementCockpit': '管理駕駛艙',
  'menu.reimbursements.financeAnalytics': '財務統計',
  'menu.reimbursements.specialAnalytics': '財務統計',
  'menu.reimbursements.analytics.reimbursements.myAnalytics': '我的統計',
  'menu.reimbursements.analytics.reimbursements.financeAnalytics': '財務統計',
  'menu.reimbursements.analytics.reimbursements.managementCockpit':
    '管理駕駛艙',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
